import React from 'react';
import { Link } from "react-router-dom";

export default function SectoranalysisDemo(props) {
    const getRec = props.getAnalsysData;
    return (
        <>
            {getRec ? <>
                <table className="table table-bordered">
                    <thead>
                        <tr className="header-row changefont">
                            <th className="indexname" size="3">Symbol</th>
                            <th className="ltp" size="3">1D</th>
                            <th className="signal" size="3"> 1W </th>
                            <th className="change" size="3"> 1M </th>
                            <th className="change" size="3">  3M </th>
                        </tr>
                    </thead>
                    <tbody>
                        {getRec.map((item, key) => (
                            <tr key={key}>
                                <td className="indexname symbol-text" size="4" >
                                    <Link to={'/sector-analysis/' + item.market_id} >{item.symbol}</Link> </td>
                                <td className="indexname symbol-text" size="2" style={{ 'color': item.color }}>
                                    {item.cp}</td>
                                <td className="indexname symbol-text" size="2" style={{ 'color': item.wcolor }}>
                                    {item.weekper}</td>
                                <td className="indexname symbol-text" size="2" style={{ 'color': item.onecolor }} >
                                    {item.onemonthper}</td>
                                <td className="indexname symbol-text" size="2" style={{ 'color': item.threecolor }} >
                                    {item.threemonthper}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
                : ''}

        </>
    )
}
